import { acLookback } from '../../math/lookback'
import { COLOR, histogram, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'AC',
  version: 1,
  label: 'Accelerator Oscillator',
  pane: 'sub',
  category: 'momentum',
  series: 'price',
  order: 260,
  inputs: [period('fastperiod', 5, 'Fast length'), period('slowperiod', 34, 'Slow length'), period('signalperiod', 5, 'Signal length')],
  outputs: [histogram('ac', 'AC', COLOR.green, COLOR.red)],
  talib: {
    functions: ['SMA', 'MEDPRICE'],
    expr:
      'AO - SMA(AO, timeperiod={signalperiod}) where AO = SMA(MEDPRICE(high, low), timeperiod={fastperiod}) - SMA(MEDPRICE(high, low), timeperiod={slowperiod})',
  },
  listed: true,
  tailSafe: true,
  lookback: ({ fastperiod, slowperiod, signalperiod }) => acLookback(fastperiod, slowperiod, signalperiod),
}
export default def
